"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAbsence = void 0;
var uuid_1 = require("uuid");
var createAbsence = function (from, to, absenceHours, omittedDates, employeeId, omitHolidays, omitWeekends, isPaid, countOnlyDaysWithShifts) {
    if (absenceHours === void 0) { absenceHours = null; }
    if (omittedDates === void 0) { omittedDates = []; }
    if (employeeId === void 0) { employeeId = '1'; }
    if (omitHolidays === void 0) { omitHolidays = true; }
    if (omitWeekends === void 0) { omitWeekends = true; }
    if (isPaid === void 0) { isPaid = true; }
    if (countOnlyDaysWithShifts === void 0) { countOnlyDaysWithShifts = true; }
    return {
        id: (0, uuid_1.v4)(),
        from: from,
        to: to,
        type_id: (0, uuid_1.v4)(),
        created_at_timestamp: '2023-01-01 12:00:00',
        is_paid: isPaid,
        duration: null,
        company_id: (0, uuid_1.v4)(),
        note: null,
        count_only_days_with_shifts: countOnlyDaysWithShifts,
        deleted_at_timestamp: null,
        recent_approved_by: null,
        recent_status_change_by: employeeId,
        year: 2023,
        series_number: String(Math.floor(Math.random() * 1000) + 1),
        updated_at_timestamp: '2023-01-01 12:00:00',
        employee_id: employeeId,
        omit_holidays: omitHolidays,
        omit_weekends: omitWeekends,
        omitted_dates: omittedDates,
        absence_hours: absenceHours,
        status: 'accepted',
    };
};
exports.createAbsence = createAbsence;
